<template>
  <sdCards headless>
    <div v-if="isCard_Loading">
      <a-spin />
    </div>

    <OverviewSalesCard v-else>
      <div class="icon-box box-primary">
        <SvgConverter :src="imgSrc" />
      </div>
      <div class="card-chunk">
        <CardBarChart2>
          <h2>{{ dataValue + ' ' + currency }}</h2>
          <span>{{ text }}</span>
        </CardBarChart2>
      </div>
    </OverviewSalesCard>
  </sdCards>
</template>

<script>
import SvgConverter from '@/components/utilities/SvgConverter.vue';
import { CardBarChart2, OverviewSalesCard } from './style';
import { priceFormat } from '@/utility/helper.js';

export default {
  components: {
    SvgConverter,
    CardBarChart2,
    OverviewSalesCard,
  },
  props: {
    text: {
      type: String,
      default: "0"
    },
    imgSrc: {
        default: require('@/static/img/icon/NewCustomer.svg')
    },
    endpoint: {
      type: String,
      default: "0"
    },
    currency: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isCard_Loading: true,
      dataValue: 0,
    };
  },
  methods: {},
  created() {
    this.getTotalUser(this.endpoint);
  },
  methods: {
    getTotalUser(param) {
      
      if(param == "0"){
        this.formatCurrency(0);
        this.isCard_Loading = false;
        return;
      }
        
      this.$appAxios.post(param)
        .then(response => {
          if (response.data.status === true) {
            this.formatCurrency(response.data.data);
          } else {
          }
          this.isCard_Loading = false;
        })
        .catch(e => {
        });
    },
    formatCurrency(value) {
      if(this.currency != '') {
        this.dataValue = priceFormat(value);
      } else {
        this.dataValue = value;
      }
    }
  },
};
</script>
